/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

const es_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

const de_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

const nl_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

const fr_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

const it_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

const pt_br2_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

const pt_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

const ja_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

const zh_ra_metric_fre = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_metric_fre = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_metric_fre(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_metric_fre", locale)
	if (locale === "en") return en_ra_metric_fre(inputs)
	if (locale === "es") return es_ra_metric_fre(inputs)
	if (locale === "de") return de_ra_metric_fre(inputs)
	if (locale === "nl") return nl_ra_metric_fre(inputs)
	if (locale === "fr") return fr_ra_metric_fre(inputs)
	if (locale === "it") return it_ra_metric_fre(inputs)
	if (locale === "pt-BR") return pt_br2_ra_metric_fre(inputs)
	if (locale === "pt") return pt_ra_metric_fre(inputs)
	if (locale === "ja") return ja_ra_metric_fre(inputs)
	return zh_ra_metric_fre(inputs)
};